var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locale-switcher"},[_c('select',{attrs:{"aria-label":"Language"},domProps:{"value":_vm.current},on:{"change":_vm.onChange}},_vm._l((_vm.locales),function(item){return _c('option',{key:item.code,domProps:{"value":item.code}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c8947e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocaleSwitcher.vue
// module id = null
// module chunks = 